interface Props {
  onNext: () => void;
}

const STEPS = [
  {
    icon: "✉️",
    title: "We'll Reach Out",
    detail:
      "Expect a call or email from your licensed notary within 2-4 hours to schedule your appointment.",
  },
  {
    icon: "📹",
    title: "Remote Video Session",
    detail:
      "Your notarization is conducted via secure video call. No need to travel — you can be anywhere in the U.S.",
  },
  {
    icon: "✍️",
    title: "Signing & Sealing",
    detail:
      "You'll e-sign your documents during the session. The notary applies their official NY State seal electronically.",
  },
  {
    icon: "💳",
    title: "Payment",
    detail:
      "Payment of $25 per notarized signature is collected at the time of service via Venmo, Cash App, or credit card.",
  },
  {
    icon: "✅",
    title: "Receive Your Documents",
    detail:
      "You'll receive your notarized documents digitally, ready for submission.",
  },
];

export function HowItWorksStep({ onNext }: Props) {
  return (
    <div className="wizard-step">
      <header className="wizard-step-header">
        <h2>What Happens Next</h2>
        <p>Here's what to expect after you submit your request.</p>
      </header>

      <ol className="wizard-how-list">
        {STEPS.map((s) => (
          <li key={s.title} className="wizard-how-row">
            <div className="wizard-how-icon" aria-hidden="true">{s.icon}</div>
            <div>
              <div className="wizard-how-title">{s.title}</div>
              <div className="wizard-how-detail">{s.detail}</div>
            </div>
          </li>
        ))}
      </ol>

      <button type="button" className="wizard-button-primary" onClick={onNext}>
        Got It — Continue
      </button>
    </div>
  );
}
